import {MdDialogRef} from '@angular/material';
import { Component, Input, OnChanges, OnInit, style } from '@angular/core';

import {ConstantsService} from 'app/services/constants-service';
import {EntityRelation} from 'app/shared/models/entity-relation.model';
import {
  EntityRelationsService,
  RelationshipPanelActions
} from 'app/entities/relations/entity-relations.service';
import {SnackBarService} from '../../../../services/snackbar.service';
import {TrackingService} from '../../../../shared/services/tracking/google-analytics-events.service';
import {TrackingConstants} from '../../../../shared/services/tracking/tracking-constants.service';
import {MessageService} from '../../../../services/messages.service';
import {EntityType} from '../../../../shared/models/entity-id-details.model';

@Component({
  templateUrl: './ubo.component.html',
    styleUrls: ['./ubo.component.css'],
})

export class UBOComponent implements OnInit {
  @Input()
  entityId: number;
  relationships = new Array<EntityRelation>();
  nestedRelationships = new Array<Array<EntityRelation>>();
  selectedRelation: EntityRelation;
    selectedRelations = new Array<EntityRelation>();
  loading = false;
  saving = false;
  personLogo = ConstantsService.DEFAULT_PERSON_MALE_LOGO;
  orgLogo = ConstantsService.DEFAULT_ORG_LOGO;

  constructor(public dialogRef: MdDialogRef<any>,
              private relationsService: EntityRelationsService,
              private trackingService: TrackingService,
              private snackBarService: SnackBarService) {
  }

  ngOnInit() {
    this.loadRelationships(this.entityId);
  }

  loadRelationships(entityId: number) {
    this.loading = true;
    const relationships = new Array<EntityRelation>();
    this.relationsService.getRelationshipsWithOffsetAndLimits(entityId, 0, 50)
      .subscribe(response => {
        if (response.arrResult.relations) {
          this.nestedRelationships.push(response.arrResult.relations);
        }
        this.loading = false;
      });
  }

  getEntityIdRelationships(relation, level) {
    this.loading = true;
    this.selectedRelation = relation;
    if (this.nestedRelationships.length > (level + 1)) {
      this.nestedRelationships.splice(level + 1, this.nestedRelationships.length);
            this.selectedRelations.splice(level, this.selectedRelations.length);
    }
        this.selectedRelations.push(relation);
    this.loadRelationships(relation.entityId);
  }

    checkRelationExists(relation) {
        return this.selectedRelations && this.selectedRelations.indexOf(relation) !== -1;
    }

  markUbo() {
    this.saving = true;
    if (!this.validateSelection()) {
      this.saving = false;
      return;
    }
    this.relationsService.markUbo(this.selectedRelation.id, this.entityId, this.selectedRelation.entityId)
      .subscribe(
        success => {
          this.callSnackBarService(success);
          this.relationsService.sendMessage(RelationshipPanelActions.UPDATE_RELATIONSHIPS.toString());
          this.trackingService
            .emitEvent(TrackingConstants.RELATIONSHIP, TrackingConstants.UBO_RELATIONSHIP, TrackingConstants.SUCCESS, 1);
          this.saving = false;
          this.dialogRef.close(success);
        },
        err => {
          this.callSnackBarService(err);
          this.trackingService
            .emitEvent(TrackingConstants.RELATIONSHIP, TrackingConstants.UBO_RELATIONSHIP, TrackingConstants.FAILURE, 0);
          this.saving = false;
          this.dialogRef.close();
        }
      );
  }

  private validateSelection(): boolean {
    if (this.selectedRelation.entityId === this.entityId) {
      this.snackBarService.showStatus({}, '', MessageService.SELF_UBO_ERROR);
      return false;
    }
    if (this.selectedRelation.entityType !== EntityType[EntityType.PERSON.toString()]) {
      this.snackBarService.showStatus({}, '', MessageService.ORG_UBO_ERROR);
      return false;
    }
    return true;
  }

  private callSnackBarService(response: any) {
    this.snackBarService
      .showStatus(response,
        MessageService.UPDATED_RELATION_SUCCESS,
        MessageService.UPDATED_RELATION_FAILURE);
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/relations/relationship/ubo/ubo.component.ts